import { render, staticRenderFns } from "./Hardware.vue?vue&type=template&id=4c70544f&scoped=true&"
import script from "./Hardware.vue?vue&type=script&lang=js&"
export * from "./Hardware.vue?vue&type=script&lang=js&"
import style0 from "./Hardware.vue?vue&type=style&index=0&id=4c70544f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70544f",
  null
  
)

export default component.exports